import { type NavigateFunction } from 'react-router-dom';
import env from '../config/env';
import { assignHref, getHref } from './location';
import { pages } from './pages';
import { CONTACT_US_SWAP, CONTACT_US_WELCOME, FAQ_LINK } from './redirectLinks';

const redirectToLogin = (): void => {
  assignHref(`${env.LOGIN_URL}?origin=${getHref()}`);
};

const redirectToDashboard = (): void => {
  assignHref(`${env.SITE_URL}`);
};

const redirectToTrialCancel = (): void => {
  assignHref(`${env.SITE_URL}/trial-cancel-subscription`);
};

const redirectToFAQ = (): void => {
  assignHref(FAQ_LINK);
};

const redirectToContactUsSwap = (): void => {
  assignHref(CONTACT_US_SWAP);
};

const redirectToContactUsWelcome = (): void => {
  assignHref(CONTACT_US_WELCOME);
};

const redirectToSwapForCredit = ({ navigate }: { navigate: NavigateFunction }): void => {
  navigate(pages.SWAP_FOR_CREDIT.path);
};

export {
  redirectToLogin,
  redirectToDashboard,
  redirectToTrialCancel,
  redirectToFAQ,
  redirectToContactUsSwap,
  redirectToContactUsWelcome,
  redirectToSwapForCredit,
};
